import type { OpsOrderIntakeRow } from "@/lib/orderIntakeClient";

export function formatIntakeDisplayDate(iso: string): string {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  const dd = String(d.getDate()).padStart(2, "0");
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const yyyy = d.getFullYear();
  return `${dd}-${mm}-${yyyy}`;
}

function customerNameFromRow(row: OpsOrderIntakeRow): string {
  const raw = row.raw_payload;
  if (!raw || typeof raw !== "object") return "Customer";
  const contact = (raw as { customer_contact?: unknown }).customer_contact;
  if (!contact || typeof contact !== "object") return "Customer";
  const name = (contact as { name?: unknown }).name;
  return typeof name === "string" && name.trim() ? name.trim() : "Customer";
}

function manufacturerLabel(
  row: OpsOrderIntakeRow,
  manufacturerNameByOrgId: ReadonlyMap<string, string>,
): string {
  if (row.organization_id === row.submitted_by_org_id) return "This org";
  return manufacturerNameByOrgId.get(row.organization_id) ?? "Manufacturer";
}

/** Sales-rep submissions list title: Customer · Manufacturer · dd-mm-yyyy */
export function formatSalesRepOrderRowLabel(
  row: OpsOrderIntakeRow,
  manufacturerNameByOrgId: ReadonlyMap<string, string>,
): string {
  const customer = customerNameFromRow(row);
  const mfg = manufacturerLabel(row, manufacturerNameByOrgId);
  const date = formatIntakeDisplayDate(row.created_at);
  return `${customer} · ${mfg} · ${date}`;
}
